
















import Vue, { PropType } from "vue";
import { Nullable, Inverter } from "@/types";

import InverterConfigurationItem from "./InverterConfigurationItem.vue";
import InverterConfigurationEditor from "@/components/InverterConfigurationManager/InverterConfigurationEditor.vue";

export default Vue.extend({
  components: {
    InverterConfigurationItem,
    InverterConfigurationEditor
  },
  props: {
    value: {
      type: Array as PropType<Inverter[]>,
      default: () => []
    },
    numberOfPanels: Number,
    inverterConfigurationId: Number,
    editMode: Boolean
  },

  data() {
    return {
      selectedIndex: -1
    };
  },

  computed: {
    selected(): Nullable<Inverter> {
      return this.selectedIndex >= 0 ? this.value[this.selectedIndex!] : null;
    }
  },

  watch: {
    inverterConfigurationId() {
      if (this.inverterConfigurationId) {
        this.updateConfiguration();
      }
    },
    numberOfPanels(val: number, oldVal: number) {
      if (val != oldVal) {
        setTimeout(() => {
          this.updateConfiguration();
        }, 2000);
      }
    },
    value: {
      immediate: true,
      handler(val) {
        if (!val.length && this.inverterConfigurationId) {
          this.updateConfiguration();
        }
      }
    }
  },

  methods: {
    async updateConfiguration() {
      const result = await this.fetchConfigDefault();
      const configuration = result.data.data.configuration;
      if (result) {
        this.$emit("input", [
          ...configuration.map((inverter: Inverter) => ({ ...inverter, amount: 0 }))
        ]);
      }
    },
    handleEdit(item: Inverter) {
      this.$emit("update:editMode", true);
      this.selectedIndex = this.value.indexOf(item);
    },

    onSave() {
      this.$emit("update:editMode", false);
      this.$emit("input", this.value);

      this.selectedIndex = this.value.findIndex((item: Inverter) => !item.model);
    },
    fetchConfigDefault(): Promise<any> {
      return this.$store.dispatch("materials/inverterConfigurations/fetch:configDefault", {
        id: this.inverterConfigurationId,
        amount: this.numberOfPanels ?? 0
      });
    }
  }
});
